export default function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "socket.sharedworker.36b2317446c7c433029e.js", {"type":"classic","name":"JamespotSocket"});
}
